import { CircleInfoIcon, FilterIcon, ImageIcon, QuestionnaireIcon } from "@xola/icons";
import React from "react";
import { Membership } from "types";
import { MembershipDescriptiveContent } from "@/components/Product/Membership/DescriptiveContent/MembershipDescriptiveContent";
import { MembershipBenefits } from "@/components/Product/Membership/MembershipBenefits/MembershipBenefits";
import { MembershipRestrictions } from "@/components/Product/Membership/MembershipRestrictions/MembershipRestrictions";
import { MembershipPhotoList } from "@/components/Product/Membership/Photos/MembershipPhotoList";
import { ProductQuestionnaire } from "@/components/Product/Questionnaire/ProductQuestionnaire";

export const useMembershipTabs = (membership?: Membership, isLoading?: boolean) => {
    return [
        {
            id: "description",
            label: "Description",
            icon: <CircleInfoIcon size="large" />,
            description: "Important details that will be presented to your customers",
            content: <MembershipDescriptiveContent membership={membership} isLoading={isLoading} />,
        },
        {
            id: "benefits",
            label: "Benefits",
            icon: (
                <span>
                    <span className="flex h-4.5 w-4.5 justify-center text-lg font-normal">$</span>
                </span>
            ),
            description: "Discounts and perks this membership offers",
            content: membership && <MembershipBenefits membership={membership} />,
            condition: !!membership,
        },
        {
            id: "restrictions",
            label: "Restrictions",
            icon: <FilterIcon size="large" />,
            description: "Limits on how and when this membership may be used",
            content: membership && <MembershipRestrictions membership={membership} />,
            condition: !!membership,
        },
        {
            id: "photos",
            label: "Photos",
            icon: <ImageIcon size="large" />,
            condition: !!membership,
            description: "Set the photo that will be shown on checkout and back office",
            content: membership && <MembershipPhotoList membership={membership} />,
        },
        {
            id: "questionnaire",
            label: "Questionnaire",
            icon: <QuestionnaireIcon size="large" />,
            condition: !!membership,
            description: "Collect additional information from your customers",
            content: membership && <ProductQuestionnaire product={membership} />,
        },
    ];
};
